import Trial from './trial'
import Acervo from './acervo'
import Degree from './degree'
import Gamification from './gamification'
import * as SpecialEntities from './special-entities'
import Module from './module'

export { Trial, Acervo, Degree, Gamification, SpecialEntities, Module }

const User = {
  Trial,
  Acervo,
  Degree,
  Gamification,
  SpecialEntities,
  Module
}

export default User
